import actionTypes from './constants';

/* */
const initialState = {
  cart: [],
  products: [],
  balance: null,
  transaction: null,
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE: {
      return {
        ...initialState,
        ...action.payload,
      };
    }
    case actionTypes.UPDATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case actionTypes.ADD_PRODUCT_TO_CART:
      return {
        ...state,
        cart: [...state.cart, action.payload],
      };
    case actionTypes.ADD_TRANSACTION:
      return {
        ...state,
        cart: [],
        transaction: action.payload.transaction,
        balance: state.balance + action.payload.refilledAmount,
      };
    default:
      return state;
  }
};
